import React from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import styles from '../actions/views/Buildings/DeviceStatistics.module.css';
import { ArrowDownUp, Wifi, WifiOff } from 'lucide-react';

const DeviceEventsTable = ({ events, loading, connected }) => {
  console.log(`We have ${events.length} events`);
  if (events.length > 0) console.dir(events);
  // Function to determine status color
  const getStatusColor = (status) => {
    switch (status) {
      case 10: return '#808080'; // Offline - Grey
      case 20: return '#00C851'; // Running - Green
      case 30: return '#33b5e5'; // Guarded - Blue
      case 40: return '#ffbb33'; // Elevated - Yellow
      case 50: return '#ff8800'; // Alert - Orange
      case 60: return '#ff4444'; // Emergency - Red
      default: return '#9aaad6';
    }
  };

  // Function to get status text
  const getStatusText = (status) => {
    switch (status) {
      case 10: return 'Offline';
      case 20: return 'Running';
      case 30: return 'Guarded';
      case 40: return 'Elevated';
      case 50: return 'Alert';
      case 60: return 'Emergency';
      default: return 'Unknown';
    }
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}>
          <ArrowDownUp size={24} className={styles.spinningIcon} />
        </div>
        <p>Loading events...</p>
      </div>
    );
  }

  return (
    <div className={styles.eventTableContainer}>
      <div className={styles.eventTableHeader}>
        <h3 className={styles.eventTableTitle}>Device Events</h3>
        <div className={styles.connectionStatus}>
          {connected ? (
            <div className={styles.connected}>
              <Wifi size={16} />
              <span>Live Updates</span>
            </div>
          ) : (
            <div className={styles.disconnected}>
              <WifiOff size={16} />
              <span>Static Data</span>
            </div>
          )}
        </div>
      </div>
      
      {events.length === 0 ? (
        <div className={styles.noEvents}>
          <p>No events found for this device.</p>
        </div>
      ) : (
        <Table className={styles.table}>
          <thead>
            <tr>
              <th><div className={styles.firstColumnHeader}>Status</div></th>
              <th>Event/Description</th>
              <th>Date</th>
              <th>Code</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event, index) => (
              <tr key={event.id || index} className={styles.eventRow}>
                <td>
                  <div className={styles.statusCell}>
                    <span 
                      className={styles.statusIndicator} 
                      style={{ backgroundColor: getStatusColor(event.status) }}
                    />
                    <span className={styles.statusText}>{getStatusText(event.status)}</span>
                  </div>
                </td>
                <td>{event.description}</td>
                <td>{moment(event.date).format('MM/DD/YYYY hh:mm:ss A')}</td>
                <td>{event.code}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default DeviceEventsTable;
